import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.PortalOrganizationList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.PortalOrganizationEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.PortalOrganizationCreate })));

export default { list, edit, create };
